import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import './glossaryTooltip.component.scss';
import isMobile from "ismobilejs";


interface Props {
  id: string;
  content: string;
}

const GlossaryTooltip: React.FC<Props> = (props) => {
  const [open, setOpen] = useState<boolean>(false);
  const mainRef = useRef<HTMLDivElement>(null);
  const innerRef = useRef<HTMLDivElement>(null);
  const mobileRef = useRef<boolean>(isMobile().any);

  const positionElement = () => {
    const element = document.getElementById(props.id);
    const box = element?.getBoundingClientRect();
    if (!!box && !!mainRef.current && !!innerRef.current) {
      let left = box.left;

      const mainBox = mainRef.current.getBoundingClientRect();

      let offset = left + mainBox.width + 32 - window.innerWidth;
      offset = Math.max(0, offset);

      mainRef.current.style.setProperty('left', `${left}px`);
      mainRef.current.style.setProperty('top', `${box.top + window.scrollY}px`);

      innerRef.current.style.setProperty('transform', `translateX(-${offset}px)`);
    }
  };

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      e.preventDefault();
      !!mobileRef.current && setOpen(!open);
    };

    const handleOpen = (e: MouseEvent) => {
      e.preventDefault();
      positionElement();
      !mobileRef.current && setOpen(true);
    };

    const handleClose = (e: MouseEvent) => {
      e.preventDefault();
      !mobileRef.current && setOpen(false);
    };

    const element = document.getElementById(props.id);

    element?.addEventListener('click', handleClick);
    element?.addEventListener('mouseover', handleOpen);
    element?.addEventListener('mouseout', handleClose);
    return () => {
      element?.removeEventListener('click', handleClick);
      element?.removeEventListener('mouseover', handleOpen);
      element?.removeEventListener('mouseout', handleClose);
    };
  }, [open, positionElement]);

  useEffect(() => {
    window.addEventListener('resize', positionElement);
    return () => {
      window.removeEventListener('resize', positionElement);
    };
  }, [positionElement]);

  useEffect(() => {
    const handleScroll = () => {
      setOpen(false);
    }
    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    }
  })

  return (
    <div className={classNames('glossary-tooltip', { 'is-visible': open })} ref={mainRef}>
      <div className="glossary-tooltip__inner" dangerouslySetInnerHTML={{ __html: props.content }} ref={innerRef} />
    </div>
  );
};

export default GlossaryTooltip;
